import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'your_supabase_url_here';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'your_supabase_anon_key_here';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Database Types
export interface UserProfile {
  id: string;
  email: string;
  credits: number;
  created_at: string;
  updated_at: string;
}

export interface EmailGeneration {
  id: string;
  user_id: string;
  target_type: string;
  business_type?: string;
  service: string;
  tone: string;
  linkedin_url?: string;
  credits_used: number;
  created_at: string;
}